const centerDistance = '150px'
const partionHeadToBody = 40
const footerHeight = 10
const backgroundColor2 = 'rgba(245,245,245,1)' //Light Gray
const backgroundColor1 = 'rgba(237,67,106,1)'
const addContactButtonColor = 'rgba(121,224,19,1)'

const styles = theme => ({
  app: {
    height: '100vh', //forces filling 100% of view
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: backgroundColor1,
    position: 'scroll',
    width: '100vw'
  },
  name: {
    color: '#fff',
    padding: '10px',
    paddingBottom: '20px'
  },
  header: {
    backgroundColor: backgroundColor1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: '50px'
  },
  photo: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  body: {
    height: `${100 - partionHeadToBody - footerHeight}%`,
    backgroundColor: backgroundColor1,
    display: 'flex',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '0% 16%'
  },
  text: {
    fontSize: '62.5%',
    margin: 0,
    padding: 0,
    display: 'flex',
    justifyContent: 'space-evenly', //Vertical Center
    alignItems: 'center',
    flexDirection: 'column'
  },
  footer: {
    height: `${footerHeight}vh`,
    backgroundColor: backgroundColor2,
    position: 'fixed',
    width: '100%',
    bottom: '0',
    height: '10vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  cards: {
    margin: '10px'
  },
  footerButton: {
    backgroundColor: backgroundColor1,
    borderRadius: '5px'
  },
  fab: {
    display: 'block',
    position: 'fixed',
    transform: `translate(calc(100vw - 100px), calc(40vh - 30px))`,
    backgroundColor: addContactButtonColor
  },
  row: {
    display: 'flex',
    justifyContent: 'center'
  },
  avatar: {
    margin: 10
  },
  bigAvatar: {
    width: centerDistance,
    height: centerDistance
  },
  avatarDefault: {
    width: '125px',
    height: '125px',
    color: 'rgba(255,255,255,1)'
  },
  menu: {
    //position: 'absolute',
    top: 0,
    left: 0,
    margin: '16px 0 0 16px',
    color: '#fff'
  }
})

export default styles
